/**
 * PostHog product analytics for the SPA.
 *
 * Event taxonomy (MVP funnel):
 *   Acquisition: landing_cta_clicked, demo_entered, signup_started, signup_completed
 *   Onboarding: onboarding_started, onboarding_step_completed, onboarding_completed,
 *               onboarding_skipped_invite, partner_invite_sent
 *   Activation: first_guest_added,
 *               dashboard_activation_viewed, dashboard_activation_step_clicked,
 *               dashboard_activation_dismissed, dashboard_activation_completed,
 *               website_onboarding_started, website_onboarding_step_completed,
 *               website_onboarding_completed, website_onboarding_skipped
 *   Monetization: upgrade_page_viewed, upgrade_cta_clicked, paywall_shown, checkout_return_viewed
 *
 * Server-side billing events (checkout_initiated, subscription_activated, etc.) live in
 * apps/functions — keep property names snake_case to match.
 */

import posthog from "posthog-js";

const enabled = Boolean(import.meta.env.VITE_POSTHOG_TOKEN);

export interface IdentifyTraits {
  email?: string | null;
  name?: string | null;
  plan?: string;
  locale?: string;
}

export function track(event: string, properties?: Record<string, unknown>): void {
  if (!enabled) return;
  posthog.capture(event, properties);
}

export function identifyUser(uid: string, traits?: IdentifyTraits): void {
  if (!enabled) return;
  posthog.identify(uid, {
    email: traits?.email ?? undefined,
    name: traits?.name ?? undefined,
    plan: traits?.plan ?? "free",
    locale: traits?.locale ?? undefined,
  });
}

export function resetAnalyticsUser(): void {
  if (!enabled) return;
  posthog.reset();
}

export function trackPageView(path: string): void {
  if (!enabled) return;
  posthog.capture("$pageview", { $current_url: path });
}
